import { LOAD_PROJECTS, ERROR_PROJECTS } from "./projectsTypes";

const initial = {
  projects: [],
  loading: true,
  error: false,
};

const projectsReducer = (state = initial, action) => {
  switch (action.type) {
    case LOAD_PROJECTS:
      return {
        projects: action.payload,
        loading: false,
        error: "",
      };
    case ERROR_PROJECTS:
      return {
        projects: [],
        loading: false,
        error: true,
      };
    default:
      return state;
  }
};

export default projectsReducer;
